$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_license'
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class EnterpriseLicenseBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-license-banner')

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-dismiss-enterprise-license-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      maxMembers: @model.seats.max
      availableLicenses: @model.seats.available
    @$el.html template(data)

    if @sendGASEvent
      Analytics.sendViewedBannerEvent
        bannerName: 'enterpriseLicenseBanner'
        source: getScreenFromUrl()
        containers:
          enterprise:
            id: @model.idEnterprise

    @

  dismiss: (e) ->
    track("Header", "Enterprise License Banner", "Dismiss")
    if @sendGASEvent
      Analytics.sendDismissedComponentEvent
        componentType: 'banner'
        componentName: 'enterpriseLicenseBanner'
        source: getScreenFromUrl()
        containers:
          enterprise:
            id: @model.idEnterprise

    Auth.me().dismissEnterpriseBannerFor @model.idEnterprise
    $(e.target).closest('.enterprise-license-banner').remove()
    e.preventDefault()
